<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Alert, Button } from '@Shelly/shelly-design-system';
	import { resetEditUpdateStore } from 'src/stores/ui/edit_lists';
	import CustomizeDeviceWizard from '../CustomizeDeviceWizard/CustomizeDeviceWizard.svelte';
	import { getVComponentStatus } from 'src/helpers/virtual_helpers/virtual_components_status_helpers';
	import { defaultStateType, getDeviceState } from 'src/stores/device-runtime/states';
	import type { Device } from 'src/types/Device';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';

	export let device: Device;

	let showCustomizeDeviceModal = false;
	$: deviceStateStore = getDeviceState(device?.id);
	$: deviceState = $deviceStateStore;
	$: disableCustomizeDeviceFromState =
		deviceState?.type > 0 && deviceState?.type < defaultStateType;

	$: disableCustomizeDevice = disableCustomizeDeviceFromState
		? true
		: device?.type == 'virtual-group'
			? getVComponentStatus(device).filter((i) => i.vcView)?.length == 0
			: false;

	const openCustomizeWizard = () => {
		resetEditUpdateStore();
		showCustomizeDeviceModal = true;
	};

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({
				onClick: openCustomizeWizard,
				loading: false,
				disabled: disableCustomizeDevice,
				label: $format('title_customize_device_card', { default: 'Customize device card' }),
			});
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

<Alert
	heading={$format('customize_parameter_alert_heading', {
		default:
			"You can customize both big and small parameter slots on your device's card. After customization, changes apply everywhere you see that device in the app.",
	})}
/>
{#if !$showNewLayout}
	<Button
		class="width-full mt-s"
		size="m"
		disabled={disableCustomizeDevice}
		on:click={openCustomizeWizard}
	>
		{$format('title_customize_device_card', {
			default: 'Customize device card',
		})}
	</Button>
{/if}
<CustomizeDeviceWizard bind:showModal={showCustomizeDeviceModal} {device} />
